import { i18n } from "@lib/i18n";

export const NETWORK_TASKS_FILTERABLE_SELECTION_STATUSES = [
    "planned",
    "in_progress",
    "filled",
] as const;

export type NetworkTasksFilterSelectionStatus =
    (typeof NETWORK_TASKS_FILTERABLE_SELECTION_STATUSES)[number];

export type NetworkTasksSelectionStatusCounts = Record<NetworkTasksFilterSelectionStatus, number>;

export const EMPTY_NETWORK_TASKS_SELECTION_STATUS_COUNTS: NetworkTasksSelectionStatusCounts = {
    planned: 0,
    in_progress: 0,
    filled: 0,
};

export function isNetworkTasksFilterSelectionStatus(
    status: string,
): status is NetworkTasksFilterSelectionStatus {
    return NETWORK_TASKS_FILTERABLE_SELECTION_STATUSES.includes(
        status as NetworkTasksFilterSelectionStatus,
    );
}

export function getNetworkTaskSelectionStatusLabel(status: string): string {
    const labels: Record<string, () => string> = {
        planned: () => i18n.network_tasks_table_selection_status_planned(),
        in_progress: () => i18n.network_tasks_table_selection_status_in_progress(),
        filled: () => i18n.network_tasks_table_selection_status_filled(),
        over: () => i18n.network_tasks_table_selection_status_over(),
    };

    return labels[status]?.() ?? status;
}
